import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { DivisionInterface } from './definitions/division-interface';
import { ErrorsInterface } from '../errors/errors-interface';
import { Observable } from 'rxjs';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface AddEmployeesToDivisionResponse {
  division: {
    addEmployeesToDivision: {
      output: DivisionInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class AddEmployeesToDivisionService {
  constructor(private apollo: Apollo) {}

  addEmployeesToDivision(
    divisionId: string,
    employeeIds: Array<string>,
    mutation: DocumentNode
  ): Observable<FetchResult<AddEmployeesToDivisionResponse>> {
    return this.apollo.mutate<AddEmployeesToDivisionResponse>({
      mutation: mutation,
      variables: {
        divisionId: divisionId,
        employeeIds: employeeIds,
      },
    });
  }
}
